import React, {useMemo} from "react";
import CategoryMapMarker from "../components/map/CategoryMapMarker";
import FontAwesome from "../components/utilities/FontAwesome";

export default function useCategoryIcons(organization) {
    const icon = useMemo(() => {
        let i
        if (organization.categories && organization.categories.length > 0) {
            i = <CategoryMapMarker category={organization.categories[0]}/>
        }
        else {
            switch (organization.type) {
                case "district":
                    i =  <FontAwesome prefix={'fas'} fixedWidth className="fa-building"/>
                    break;
                case "school":
                    i = <FontAwesome prefix={'fas'} fixedWidth className="fa-school"/>
                    break;
                case "department":
                case "organization":
                case "group":
                    i = <FontAwesome prefix={'fas'} fixedWidth className="fa-users"/>
                    break;
                case "team":
                    i = <FontAwesome prefix={'fas'} fixedWidth className="fa-futbol"/>
                    break;
                case "classroom":
                    i = <FontAwesome prefix={'fas'} fixedWidth className="fa-book"/>
                    break;
                case "collection":
                    i = <FontAwesome prefix={'fas'} fixedWidth className="fa-object-group"/>
                    break;
                case "section":
                    i = <FontAwesome prefix={'fas'} fixedWidth className="fa-clone"/>
                    break;
                default:
                    i = <FontAwesome prefix={'fas'} fixedWidth className="fa-user"/>
                    break;
            }
        }
        return i;
    },[])
    return icon;
}
